export default "__VITE_ASSET__No34Krjc__"